module.exports = __webpack_public_path__ + "img/berkeley-dagger.ae4e03d0.svg";